import { TicketInput } from '../Forms/TicketForm/types';
import { HotelInput } from '../Forms/HotelForm/types';
import { InsuranceInput } from '../Forms/InsuranceForm/types';
import { TransferInput } from '../Forms/TransferForm/types';
import { ExtraInput } from '../Forms/ExtraForm/types';

type CustomerPaymentInput = {
  totalAmount?: number;
  depositDate?: Date;
  totalDate?: Date;
};

export type PackageState = {
  hotels: HotelInput[];
  transfers: TransferInput[];
  insurances: InsuranceInput[];
  tickets: TicketInput[];
  extras: ExtraInput[];
  packageName: string;
  customerId: string;
  netTotal: number;
  totalDate: Date;
  depositDate: Date;
  total: number;
};

export enum PackageActionType {
  ADD_HOTEL = 'ADD_HOTEL',
  ADD_TRANSFER = 'ADD_TRANSFER',
  ADD_INSURANCE = 'ADD_INSURANCE',
  ADD_TICKET = 'ADD_TICKET',
  SET_PACKAGE_NAME = 'SET_PACKAGE_NAME',
  REMOVE_HOTEL = 'REMOVE_HOTEL',
  REMOVE_TRANSFER = 'REMOVE_TRANSFER',
  REMOVE_INSURANCE = 'REMOVE_INSURANCE',
  REMOVE_TICKET = 'REMOVE_TICKET',
  EDIT_HOTEL = 'EDIT_HOTEL',
  EDIT_TRANSFER = 'EDIT_TRANSFER',
  EDIT_INSURANCE = 'EDIT_INSURANCE',
  EDIT_TICKET = 'EDIT_TICKET',
  EDIT_EXTRA = 'EDIT_EXTRA',
  ADD_EXTRA = 'ADD_EXTRA',
  REMOVE_EXTRA = 'REMOVE_EXTRA',
  UPSERT_CUSTOMER_PAYMENT = 'UPSERT_PACKAGE_PAYMENT'
}

type AddHotelAction = {
  type: PackageActionType.ADD_HOTEL;
  payload: HotelInput;
};

type AddTransferAction = {
  type: PackageActionType.ADD_TRANSFER;
  payload: TransferInput;
};

type AddInsuranceAction = {
  type: PackageActionType.ADD_INSURANCE;
  payload: InsuranceInput;
};

type AddTicketAction = {
  type: PackageActionType.ADD_TICKET;
  payload: TicketInput;
};

type SetPackageNameAction = {
  type: PackageActionType.SET_PACKAGE_NAME;
  payload: string;
};

type RemoveHotelAction = {
  type: PackageActionType.REMOVE_HOTEL;
  payload: {
    id: string;
  };
};

type RemoveTransferAction = {
  type: PackageActionType.REMOVE_TRANSFER;
  payload: {
    id: string;
  };
};

type RemoveInsuranceAction = {
  type: PackageActionType.REMOVE_INSURANCE;
  payload: {
    id: string;
  };
};

type RemoveTicketAction = {
  type: PackageActionType.REMOVE_TICKET;
  payload: {
    id: string;
  };
};

type EditHotelAction = {
  type: PackageActionType.EDIT_HOTEL;
  payload: {
    id: string;
    values: HotelInput;
  };
};

type EditTransferAction = {
  type: PackageActionType.EDIT_TRANSFER;
  payload: {
    id: string;
    values: TransferInput;
  };
};

type EditInsuranceAction = {
  type: PackageActionType.EDIT_INSURANCE;
  payload: {
    id: string;
    values: InsuranceInput;
  };
};

type EditTicketAction = {
  type: PackageActionType.EDIT_TICKET;
  payload: {
    id: string;
    values: TicketInput;
  };
};

type EditExtraAction = {
  type: PackageActionType.EDIT_EXTRA;
  payload: {
    id: string;
    values: ExtraInput;
  };
};

type AddExtraAction = {
  type: PackageActionType.ADD_EXTRA;
  payload: ExtraInput;
};

type RemoveExtraAction = {
  type: PackageActionType.REMOVE_EXTRA;
  payload: {
    id: string;
  };
};

type UpsertCustomerPaymentAction = {
  type: PackageActionType.UPSERT_CUSTOMER_PAYMENT;
  payload: CustomerPaymentInput;
};

export type PackageAction =
  | AddHotelAction
  | AddTransferAction
  | AddInsuranceAction
  | AddTicketAction
  | SetPackageNameAction
  | RemoveHotelAction
  | RemoveTransferAction
  | RemoveInsuranceAction
  | RemoveTicketAction
  | EditHotelAction
  | EditTransferAction
  | EditInsuranceAction
  | EditTicketAction
  | EditExtraAction
  | AddExtraAction
  | RemoveExtraAction
  | UpsertCustomerPaymentAction;
